import { Component, Input, OnChanges } from '@angular/core';
import { conditioanlsFeilds, selectRelations } from 'app/global/content-relation';
import { GlobalService } from 'app/global/global.service';
import { Block } from 'app/interfaces/blocks';
import { ConditioanlsFeilds } from '../general-popover-settings/general-popover-settings.dto';
import { GeneralPopoverSettingsComponent } from '../general-popover-settings/general-popover-settings.component';
import { SelectedFieldEnum } from 'app/interfaces/fields.dto';

@Component({
  selector: 'app-conditional-fields',
  templateUrl: './conditional-fields.component.html',
  styleUrl: './conditional-fields.component.scss',
  providers: [GeneralPopoverSettingsComponent]
})
export class ConditionalFieldsComponent implements OnChanges {

  @Input() block: Block;
  @Input() uuid: string;
  constructor(private globalService: GlobalService, public generalPopoverSettings: GeneralPopoverSettingsComponent) { }
  public conditional_fields:ConditioanlsFeilds[];
  public selectedConditioanl:ConditioanlsFeilds[];
  public role_id: number | string = 0;
  public SelectedFieldEnum = SelectedFieldEnum;

  ngOnChanges() {
    this.updateSettings();
  }

  async updateSettings() {
    this.selectedConditioanl = (this.block?.connected_parent_conditional_id ?? []).filter((field) => {
      const uuid = ['droplist', 'list'].includes(field.type) ? field.main_uuid : field.uuid;
      const isSemiHidden = this.globalService.fields_data[uuid]?.semi_hidden_field === 1;
      return document.querySelector(`.drag-fields[uuid="${uuid}"]`) || isSemiHidden;
    });
    this.fetchConditioanlsFeilds();
  }

  /**
       * collect all the conditioanl fields expect own content fields
       */
  fetchConditioanlsFeilds() {
    this.conditional_fields = [];
    this.conditional_fields = conditioanlsFeilds(this.block, this.globalService, this.generalPopoverSettings);
  }



  /**
   * Select the field that will link with relation
   * @param field 
   */
  onSelectRelations(fields: ConditioanlsFeilds[]) {
    const currentUuid = this?.uuid;
    this.block = selectRelations(fields, currentUuid, this.globalService, this.block);
    this.selectedConditioanl = fields;
  }



  /**
   * auto select the saved fields in the dropdown
   * @param item 
   * @param selected 
   * @returns 
   */
  selectedFeildFn = (item, selected) => { if (selected.uuid && item.uuid) { return item.uuid === selected.uuid; } };

}
